export class CourseVisibilityModel {
    displayCourseYear: boolean = false;
    displayCouseMap: boolean = false;
    displayLessonObjectives: boolean = false;
}